export default __webpack_public_path__ + "media/images/backup_logo/logo-symbol-wordmark-pride-07938b22d3f3aeca8007cb6cc304ae0e.svg";